module.exports = __webpack_public_path__ + "img/Blog.eedb209.png";